// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"1c923fa9","264":"a35292d3","350":"22f7aea6","521":"b40ad61b","586":"7b45cb30","592":"bc01cbe8","682":"edeb0545","709":"396505a9","760":"94315c34","820":"0fe6708b","877":"e6443df2","886":"bcebc832","918":"5960a0e2","934":"6270b265","973":"a7696905"}[chunkId] + ".chunk.js";
};